import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { SetUser } from "../util/Helper";

const SetUserCookies = () => {
  const { user, isAuthenticated, getAccessTokenSilently,getAccessTokenWithPopup } = useAuth0();
  const [userMetadata] = useState(null);

  useEffect(() => {

    

    const getUserMetadata = async () => {
  
      try {
        
        const domain = "dev-wush4mixt8nevomp.us.auth0.com";
        const accessToken = await getAccessTokenSilently();
        
        const userDetailsByIdUrl = `https://${domain}/api/v2/users/${user.sub}`;
  
        const metadataResponse = await fetch(userDetailsByIdUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
  
        const meta = await metadataResponse.json();
        console.log(meta);


        /*
        const orgDetailsByIdUrl = `https://${domain}/api/v2/users/${user.sub}/organizations`;
  
        const orgdataResponse = await fetch(orgDetailsByIdUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        
        const org = await orgdataResponse.json();
        console.log(org);
*/
        /**/
        user.access_token = await getAccessTokenSilently({
          audience: `https://dev-api.binderdrop.com/`,
          scope: "brokers:read",
        });
        
        
        SetUser(user);
        console.log(user);
        window.location.href = window.location.origin;

      } catch (e) {
        console.log("ERROR SETTING COOKIES");
        console.log(e.message);
      }
    };
  
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);
  return (
      <div className="fullScreen">
       SETTING USER DATA
      </div>
  );
};

export default SetUserCookies;